import React from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Likes from "arena/components/Likes";
import FavoriteButton from "arena/components/FavoriteButton";
import ShareButton from "arena/components/ShareButton";
import SubscribeContentButton from "core/components/SubscribeContentButton";
import { useArena } from "core/components/ArenaProvider";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function ContentControls({
  contentId,
  isFavoritesEnabled,
  isLikesEnabled,
  isShareEnabled,
  shareData,
  likes,
  content,
}) {
  const arena = useArena();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const isCollection = content?.type === "COLLECTION";
  const showSubscribe = isCollection && arena?.isRegistrationEnabled;
  const isInviteMode =
    arena?.isChatEnabled &&
    content?.type === "STREAM" &&
    content?.chatRoom?.enabled;

  const showIconButtons =
    isLikesEnabled || isFavoritesEnabled || isShareEnabled;

  return (
    <Box
      sx={{
        overflowX: "auto",
        width: "100%",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        px: { xs: 1.25, sm: 3 },
      }}
    >
      <Stack
        direction="row"
        spacing={{ xs: 0.75, sm: 2 }}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        {showIconButtons && (
          <Paper
            elevation={0}
            sx={{
              display: "inline-flex",
              borderRadius: 50,
              overflow: "hidden",
              maxWidth: "100%",
              backgroundColor: "background.body",
              border: "1px solid",
              borderColor: "rgba(255, 255, 255, 0.30)",
            }}
          >
            <Stack direction="row" spacing={0} alignItems="center">
              {isLikesEnabled && (
                <Likes
                  contentId={contentId}
                  likes={likes}
                  borderRadius={0}
                  compact={!sm}
                />
              )}
              {isLikesEnabled && (isFavoritesEnabled || isShareEnabled) && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ bgcolor: "background.body" }}
                />
              )}
              {isFavoritesEnabled && (
                <FavoriteButton contentId={contentId} compact={!sm} />
              )}
              {(isFavoritesEnabled || isLikesEnabled) && isShareEnabled && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ bgcolor: "background.body" }}
                />
              )}
              {isShareEnabled && (
                <ShareButton
                  shareData={shareData}
                  isInviteMode={isInviteMode}
                  compact={!sm}
                />
              )}
            </Stack>
          </Paper>
        )}

        {showSubscribe && <SubscribeContentButton content={content} />}
      </Stack>
    </Box>
  );
}

ContentControls.propTypes = {
  contentId: PropTypes.string,
  isFavoritesEnabled: PropTypes.bool,
  isLikesEnabled: PropTypes.bool,
  isShareEnabled: PropTypes.bool,
  likes: PropTypes.object,
  shareData: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  content: PropTypes.object,
};
